import { useQuery } from "@tanstack/react-query";
import { api, buildQueryString } from "@/lib/api";

export interface PiecanLinkResponse {
  success: boolean;
  eligible?: boolean;
  url?: string;
}

/**
 * Fetches the PieCan handoff link for a user from the backend.
 * The returned `url` carries a tier-1 grant token when the user is an
 * eligible tier-1 purchaser, and is a plain PieCan link otherwise.
 */
export function usePiecanLink(userId: string | null | undefined) {
  return useQuery({
    queryKey: ["partner", "piecan-link", userId],
    queryFn: () =>
      api.get<PiecanLinkResponse>(
        `/partner/piecan-link${buildQueryString({ user_id: userId! })}`,
      ),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
}
